<template>
  <div
    class="
      sm:content sm:pt-16 sm:pl-12
      flex flex-col
      sm:pb-8 sm:pr-12
      relative
      p-6
    "
  >
    <p class="font-bold text-2xl">Добавление команды</p>
    <div
      class="
        flex flex-col
        w-full
        lg:w-5/6
        xl:w-5/6
        lg:justify-between
        xl:justify-between
        pb-2
        lg:flex-row
        xl:flex-row
      "
    >
      <p
        class="
          cursor-pointer
          px-3
          py-2
          rounded-full
          border-2
          font-semibold
          mt-6
        "
        style="font-size: 0.95rem"
        :class="{
          'border-brand-light': isNewTeam,
          'border-menuOrder-gray-light': !isNewTeam,
        }"
        @click.prevent="changeOption(true)"
      >
        Создать новую команду
      </p>
      <p
        class="
          cursor-pointer
          px-3
          py-2
          rounded-full
          border-2
          font-semibold
          mt-6
        "
        style="font-size: 0.95rem"
        :class="{
          'border-brand-light': !isNewTeam,
          'border-menuOrder-gray-light': isNewTeam,
        }"
        @click.prevent="changeOption(false)"
      >
        Выбрать созданную команду
      </p>
    </div>
    <div class="mt-8" v-if="!isNewTeam">
      <div
        class="
          w-full
          flex flex-col
          font-normal
          mb-8
          text-sm
          lg:text-sm
          xl:text-fullhd-warning
          warning-text
        "
      >
        <p>
          <strong class="text-brand-light font-semibold">Внимание!&nbsp;</strong
          >Вы добавляете в список участников команду, которая уже создана на
          портале. Информация о капитане команды добавляется автоматически.
          <br class="hidden lg:inline-block" />
          Убедитесь, что информация о команде соответствует команде, участвующей
          в игре.
        </p>
      </div>
      <select-team
        class="w-full lg:w-1/2 xl:w-1/2"
        :isNewRegistration="true"
        :options="options"
        :teams-loaded="teamsLoaded"
        @input="autofillTeam"
        @searched="getTeams"
      ></select-team>
      <span
        class="text-sm text-red"
        v-if="form.errors.has('team_id')"
        v-text="form.errors.first('team_id')"
      ></span>
    </div>
    <div>
      <div class="w-full sm:w-1/2 mt-5">
        <div v-if="isNewTeam">
          <moz-input
            class=""
            placeholder="Название команды"
            v-model="form.team_name"
          ></moz-input>
          <span
            class="text-sm text-red"
            v-if="form.errors.has('team_name')"
            v-text="form.errors.first('team_name')"
          ></span>
        </div>
        <div>
          <moz-input
            class=""
            placeholder="Контактное лицо"
            v-model="form.user_name"
            :readonly="!isNewTeam"
            :error="form.errors.first('user_name')"
          ></moz-input>
          <span
            class="text-sm text-red"
            v-if="form.errors.has('user_name')"
            v-text="form.errors.first('user_name')"
          ></span>
        </div>
      </div>
      <div class="flex flex-col sm:flex-row">
        <div class="w-full sm:w-1/3 mr-3">
          <moz-input
            placeholder="Телефон для связи"
            type="tel"
            inputmode="tel"
            v-model="form.phone"
            :readonly="isPhoneReadonly(form.phone)"
          ></moz-input>
          <span
            class="text-sm text-red"
            v-if="form.errors.has('phone')"
            v-text="form.errors.first('phone')"
          ></span>
        </div>
        <div class="w-full sm:w-1/3 mr-3">
          <moz-input
            class=""
            placeholder="E-mail"
            v-model="form.email"
            :readonly="!isNewTeam && form.email !== '' && form.email !== null"
          ></moz-input>
          <span
            class="text-sm text-red"
            v-if="form.errors.has('email')"
            v-text="form.errors.first('email')"
          ></span>
        </div>
        <div class="w-full sm:w-1/3 mr-3">
          <moz-input
            class="w-full lg:w-1/2 xl:w-1/2"
            @input="calculate"
            placeholder="Игроков"
            v-model="form.player_count"
          ></moz-input>
          <span
            class="text-sm text-red"
            v-if="form.errors.has('player_count')"
            v-text="form.errors.first('player_count')"
          ></span>
        </div>
        <!-- <moz-input class="w-1/6 mr-3" v-if="!isCorpLeague" placeholder="К оплате" :readonly="true" :alwaysFocused="true" v-model="form.totalCost"></moz-input> -->
      </div>

      <div class="sm:mt-20" v-if="isCorpLeague">
        <div class="w-full mb-8 mt-8">
          <moz-input
            v-model="form.company_name"
            type="text"
            placeholder="Название компании"
          />
          <span
            class="text-sm text-red"
            v-if="form.errors.has('company_name')"
            v-text="form.errors.first('company_name')"
          ></span>
        </div>
        <div class="w-full mb-8 mt-8">
          <moz-input
            v-model="form.company_comment"
            type="text"
            placeholder="Краткая информация"
          />
          <span
            class="text-sm text-red"
            v-if="form.errors.has('company_comment')"
            v-text="form.errors.first('company_comment')"
          ></span>
        </div>
      </div>
      <moz-input
        v-if="opened_from === 'registration-data'"
        class=""
        placeholder="Комментарий"
        v-model="form.comment"
      ></moz-input>

      <img
        @click="$emit('close')"
        class="
          hidden
          sm:block
          hover:text-grey-darkest
          cursor-pointer
          absolute
          pin-t pin-r
          m-4
        "
        alt=""
        src="@/assets/SVG/cross-partners.svg"
      />
    </div>
    <div class="mt-10" v-if="isCorpLeague">
      <vue-upload-component
        ref="upload"
        class="upl"
        v-model="uploadedCompanyLogos"
        :multiple="true"
        :drop="true"
        :drop-directory="true"
        :thread="5"
        :maximum="5"
        @input-filter="inputFilter"
      >
        <slot v-if="uploadedCompanyLogos.length < 5">
          <div class="flex flex-row items-center cursor-pointer h-8">
            <div
              @click="addLogoClick"
              class="
                hover-up
                outline-none
                rounded-full
                flex flex-row
                justify-center
                items-center
                h-8
                w-8
                bg-brand-light
                cursor-pointer
              "
            >
              <font-awesome-icon
                class="text-white text-xl"
                :icon="['fal', 'plus']"
              >
              </font-awesome-icon>
            </div>
            <div
              @click="addLogoClick"
              class="text-xs text-additional-text font-bold ml-4"
            >
              Добавить логотип компании
            </div>
          </div>
        </slot>
        <slot v-else>
          <div class="mx-5 mt-5 h-8 cursor-pointer"></div>
        </slot>
      </vue-upload-component>
      <div class="w-full flex items-center my-6">
        <div
          v-for="image in uploadedCompanyLogos"
          :key="image.id"
          class="image-cont w-24 h-24 mr-4 border"
          @click="deleteUploadedLogo(image)"
        >
          <img :src="getUrlObject(image)" class="image" alt=""/>
          <div class="image-shadow">
            <img class="w-6 h-6" src="@/assets/SVG/trash-bin-white.svg" alt />
          </div>
        </div>
      </div>
      <span
        v-show="fileFormatError"
        class="text-red text-10px md:text-xs font-normal"
        v-text="'Неверный формат файлов'"
      ></span>
    </div>
    <button
      @click="saveNewTeam"
      :disabled="!isAllSelected"
      :class="spinner ? 'text-brand-light' : 'text-white'"
      class="
        button
        w-full
        sm:w-auto
        ml-auto
        mt-12
        bg-brand-light
        font-bold
        px-8
        py-3
        rounded-full
        relative
      "
    >
      Добавить команду
      <img
        v-if="spinner"
        class="absolute spinner"
        src="@/assets/SVG/tail-spin.svg"
        alt=""
      />
    </button>
  </div>
</template>

<script>
import client from '@/clients/partners';
import Form from 'form-backend-validation';
import VueUploadComponent from 'vue-upload-component';
import ModalMixin from '@/mixins/modals.js';
import { mapActions, mapState } from 'vuex';
import OnClickOutside from '@/views/OnClickOutside.vue';
import SelectTeam from '@/views/partners/current-registration/selectTeam.vue';

export default {
  name: 'new-registration-modal',
  props: {
    eventId: {
      type: String,
    },
    // eventPrice: { type: Any },
    isCorpLeague: { type: Boolean },
    opened_from: { type: String },
    step5: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [ModalMixin],
  components: {
    SelectTeam,
    OnClickOutside,
    Form,
    VueUploadComponent,
  },
  data() {
    return {
      form: new Form(
        {
          team_id: '',
          team_name: '',
          user_name: '',
          phone: '',
          email: '',
          player_count: '',
          totalCost: '',
          comment: '',
          event_day_id: this.eventId,
          company_name: '',
          company_comment: '',
          company_files: [],
        },
        { http: client },
      ),
      uploadedCompanyLogos: [],
      fileFormatError: false,
      spinner: false,
      isNewTeam: true,
      errorText: '',
      test: '',
      base: process.env.VUE_APP_MP_PARTNERS_BACKEND,
      options: [],
      teamsHolder: [],
      teamsLoaded: false,
    };
  },
  created() {
    this.getTeams();
    if (this.isCorpLeague) this.form.totalCost = this.event_price;
    if (!this.opened_from) {
      this.opened_from = this.$route.params.opened_from;
    }
  },
  methods: {
    ...mapActions(['selectShowModal']),
    ...mapActions(['selectModalText']),
    getUrlObject(logoUploadObject) {
      return URL.createObjectURL(logoUploadObject.file);
    },
    getTeams(search) {
      this.options = [];
      this.teamsHolder = [];
      this.teamsLoaded = false;
      client
        .get(`${this.base}/teams-for-play`, {
          params: {
            sort: 'name,-id',
            city_id: this.cityUserId,
            'filter[like]': search,
          },
        })
        .then(({ data }) => {
          data.data.forEach((team) => {
            this.options.push(team.name);
            this.teamsHolder.push(team);
          });
          this.teamsLoaded = true;
        });
    },
    changeOption(value) {
      this.isNewTeam = value;
      this.form.team_name = '';
      this.form.user_name = '';
      this.form.email = '';
      this.form.phone = '';
      this.form.player_count = '';
      this.form.comment = '';
    },
    deleteUploadedLogo(file) {
      this.$refs.upload.remove(file);
    },

    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Filter non-image file
        // Will not be added to files
        if (!/\.(jpg|png|psd|ai|svg)$/i.test(newFile.name)) {
          this.fileFormatError = true;
          return prevent();
        }

        if (this.uploadedCompanyLogos.length > 5) {
          return prevent();
        }
      }
    },
    addLogoClick() {
      const label = document.querySelector('.upl input');
      console.dir(label);
      label.click();
      this.fileFormatError = false;
    },
    saveNewTeam() {
      this.spinner = true;
      if (this.step5) {
        console.log('LOOK', this.form);
      } else {
        this.form.company_files = this.uploadedCompanyLogos.map(item => item.file);
        this.form
          .post('/applications')
          .then(resp => this.$emit('saved'))
          .catch((error) => {
            // this.errorText = ;
            /* this.selectShowModal(true);
            for (let error in this.form.errors.errors) {
              this.selectModalText(this.form.errors.errors[error][0])
              return
            } */
          })
          .finally(() => {
            this.spinner = false;
          });
      }
    },
    calculate() {
      if (!this.isCorpLeague) {
        this.form.totalCost = (this.form.player_count * this.event_price) / 100;
      }
    },
    autofillTeam(team) {
      if (this.teamsHolder && this.teamsHolder.length) {
        const selected_team = this.teamsHolder[team];
        this.form.team_name = selected_team.name;
        this.form.captain = selected_team.captain.name;
        this.form.user_name = selected_team.captain.name;
        if (!selected_team.captain.phone) {
          this.form.phone = '';
        } else {
          this.form.phone = selected_team.captain.phone;
        }
        this.form.email = selected_team.captain.email;
        this.form.player_count = null;
        this.form.team_id = selected_team.id;
        this.calculate();
      }
    },
    isPhoneReadonly(phone) {
      let phoneLength = 12;

      if (this.cityProps.phone_code === '49') phoneLength = 15; // Костыль для Германии

      if (this.cityProps.phone_code === '375' || this.cityProps.phone_code === '998') {
        phoneLength = 13;
      }// Костыль для Беларуси

      // Костыль для Узбекистана
      if (this.cityProps.phone_code === '62') {
        phoneLength = 14;
      } // Костыль для Бали

      return !this.isNewTeam && phone.length === phoneLength;
    },
  },
  computed: {
    ...mapState({
      cityUserId: state => state.auth.user.city_id,
    }),
    cityProps() {
      return this.$store.getters.cityProps;
    },
    isAllSelected() {
      if (
        this.form.team_name !== '' &&
        this.form.captain !== '' &&
        this.form.player_count !== '' &&
        this.form.email !== '' &&
        this.form.phone !== '' &&
        this.form.totalCost !== ''
      ) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style scoped>
.button:disabled {
  background-color: gray !important;
}

.image-cont {
  @apply flex justify-center items-center relative;
  border-radius: 0.25rem;
}

.image {
  border-radius: 0.25rem;
  z-index: 0;
}

.upl {
  padding-top: 5px;
  padding-bottom: 5px;
}

.image-shadow {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.726);
  border-radius: 0.25rem;
  color: white;
  display: flex;
  font-size: 0.875rem;
  justify-content: center;
  align-items: center;
  opacity: 0;
}

.image-shadow:hover {
  opacity: 1;
  color: transparent;
  cursor: pointer;
}

.upl >>> label {
  z-index: -1 !important;
  cursor: pointer;
}

.spinner {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.warning-text {
  /*font-family: "Montserrat Regular";*/
  font-family: "Montserrat", "Montserrat Regular";
}
</style>
